/**
 * Configuration class
 */

var _userData = undefined;

// The config param only work for server side.
var ApplicationContext = function () {
    // used to store user grid/list view style to keep it consitant user experience.
    this.styleStore = {};
};

ApplicationContext.prototype.setup = function(config) {
    console.log(`ApplicationContext:`)
    console.log(JSON.stringify(config))
    this.assetUrlPrefix = config.assetUrlPrefix;
    this.contentServer = config.contentServer;
    this.componentEditor = config.componentEditor;
    this.symbolEditor = config.symbolEditor;
    this.footprintEditor = config.footprintEditor;
    this.packageEditor = config.packageEditor;
    this.packageLibrary = config.packageLibrary;
    this.adskAccountUrl = config.adskAccountUrl;
    this.defaultUserAvatar = config.defaultUserAvatar;
    this.gaAccount = config.gaAccount;
    this.tealiumURL = config.tealiumURL;

    this.env = config.env;
};

ApplicationContext.prototype.setUserData = function(data) {
    _userData = data;
};

ApplicationContext.prototype.getUserData = function() {
    return _userData;
};

ApplicationContext.prototype.getDefaultUserAvatar = function() {
    return this.defaultUserAvatar;
};

ApplicationContext.prototype.contentUrl = function() {
    return this.contentServer.server + "/" + this.contentServer.tenant;
};

ApplicationContext.prototype.detDataModelVersion = function() {
    return this.contentServer.dataModelVersion;
};

ApplicationContext.prototype.getComponentEditor = function() {
    return this.componentEditor;
};

ApplicationContext.prototype.getSymbolEditor = function() {
    return this.symbolEditor;
};

ApplicationContext.prototype.getFootprintEditor = function() {
    return this.footprintEditor;
};

ApplicationContext.prototype.getPackageEditor = function() {
    return this.packageEditor;
};

ApplicationContext.prototype.getPackageLibrary = function() {
    return this.packageLibrary;
};

ApplicationContext.prototype.getAdskAccountUrl = function() {
    return this.adskAccountUrl;
};

ApplicationContext.prototype.onLibraryChange = function(count) {
    if(isNaN(count)) {
        throw "Input is wrong.";
    } else if(_userData && _userData.usage) {
        _userData.usage.library = parseInt(_userData.usage.library) + count;
    }
}

module.exports = new ApplicationContext();
